module.exports = __webpack_public_path__ + "static/img/mv-logo.d80136c4.png";